var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visibleDialog)?_c('f-dialog',_vm._b({ref:"dialog",on:{"close":_vm.onClose}},'f-dialog',_vm.dialogProps,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }